import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import OKomBreadcrumb from '../Components/OsloKommuneUI/OKomBreadcrumb';
import { useUserContext } from '../Components/StateContext/UserContext';

interface PaameldingTile {
  label: string;
  icon: string;
  href?: string;
  disabled: boolean;
}

const renderTile = (tile: PaameldingTile, key: number) => {
  const card = (
    <div className="ods-status-card frontpage-card">
      <div className="ods-status-card__content">
        <span className={`ods-icon ods-icon--size-kilo ods-icon--size-echo-breakpoint-medium ${tile.icon}`} aria-hidden="true"></span>
        <span className="ods-text--size-kilo ods-text--size-echo-breakpoint-medium">{tile.label}</span>
      </div>
    </div>
  );
  return (
    <div key={key} className={tile.disabled ? 'ods-grid__column--6 ods-grid__column--4-breakpoint-medium ods-color-text-grayscale-10' : 'ods-grid__column--6 ods-grid__column--4-breakpoint-medium'}>
      {tile.disabled || !tile.href ? card : (
        <a href={tile.href} className="o-kom-link" style={{ display: 'block' }}>{card}</a>
      )}
    </div>
  );
};

const PaameldingView: React.FC<RouteComponentProps> = () => {
  const { userRoles } = useUserContext();
  const isAdmin = userRoles.includes('admin');
  const canEditParticipants = userRoles.includes('localadmin') || isAdmin;

  const tiles: PaameldingTile[] = [
    // Localadmin/admin only: edit existing participants within their own department.
    ...(canEditParticipants ? [
      { label: 'Endre påmeldinger eksamen', icon: 'ods-icon--document', href: '/pamelding/endre-eksamen', disabled: false },
      { label: 'Endre påmeldinger athletics', icon: 'ods-icon--document', href: '/pamelding/endre-athletics', disabled: false },
    ] : []),
    // Admin only: overview of changes made by localadmins.
    ...(isAdmin ? [
      { label: 'Endringslogg', icon: 'ods-icon--document', href: '/auditlog', disabled: false },
    ] : []),
  ];

  return (
    <>
      <OKomBreadcrumb path='Påmelding'></OKomBreadcrumb>
      <div className="ods-grid ods-grid--gap ods-grid--center ods-margin-top-11 ods-text--align-center">
        {tiles.map((tile, i) => renderTile(tile, i))}
      </div>
    </>
  );
};

export default withRouter(PaameldingView);
